import React, { Component } from 'react';
import './styles.css';
import DarkSectionLayout from '../../DarkSectionLayout';

class Header extends Component {
	render() {
		return (
			<DarkSectionLayout>
				<div className="production-fixed-costs-layout-header">
					{this.props.children}
				</div>
			</DarkSectionLayout>
		);
	}
}

export default Header;
